/**
 * Share-card tagline pool.
 *
 * Brand voice anchors:
 *   - Readiness / preparedness — the through-line of every martial art ever
 *   - Fire metaphor — temper, embers, banked coals, perpetual flame
 *   - No triumphalism / no shaming — these celebrate showing up, not winning
 *
 * Use `taglineFor(context)` to get one. Context hints bias toward appropriate
 * flavor (promotion vs PR vs streak), with random rotation within a bucket so
 * the same user posting two cards in a row gets variety.
 *
 * Banned: any "forge" cognate (competing app name). Use temper / kiln / kindle
 * / cinder / coal / flame / ember instead.
 */

const POOL = {
  // Promotion / rank — earned through years, ceremony moments.
  // Quiet-confidence anchor for the achievement.
  promotion: [
    'Tempered, not broken.',
    'Calm flame. Sharp edge.',
    'Earned in reps.',
    'The fire holds.',
    'Quiet heat.',
    'Bring the heat.',
  ],
  // Current-rank / "I train here" state share — readiness anchor, less ceremonial.
  current: [
    'Trained for what\'s unwritten.',
    'Hot before the bell.',
    'Show up already warm.',
    'Don\'t draw cold steel.',
    'Always ready.',
    'Stay tempered.',
    'Bring the heat.',
  ],
  // PR / strength milestone — the heaviest, the new line.
  pr: [
    'Heavier than yesterday.',
    'New line held.',
    'Heat made iron.',
    'Tempered to the new weight.',
    'Bring the heat.',
  ],
  // Session-count milestone — consistency reward.
  sessions: [
    'Showing up is the work.',
    'The fire kept lit.',
    'Banked, not burned.',
    'Cinder by cinder.',
    'Bring the heat.',
  ],
  // Streak — the long arc, what readiness actually looks like.
  // "Stoking" anchor — tending the flame, not chasing it.
  streak: [
    'Stoke the eternal flame.',
    'Perpetual flame.',
    'The fire held.',
    'Tend the fire.',
    'Banked, not dormant.',
    'The kiln remembers.',
    'Bring the heat.',
  ],
  // Fallback / unknown context.
  default: [
    'Bring the heat.',
    'Always ready.',
    'The fire holds.',
  ],
};

export const taglineFor = (context = 'default') => {
  const pool = POOL[context] || POOL.default;
  return pool[Math.floor(Math.random() * pool.length)];
};

export const allTaglines = POOL;
